import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";

const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const DEPARTMENT_COLLECTION_ID = import.meta.env.VITE_DEPARTMENT_COLLECTION_ID;
const DATA_SEQUENCES_COLLECTION_ID = import.meta.env.VITE_DATA_SEQUENCES_COLLECTION_ID;

export interface Department {
    $id: string;
    departmentName: string;
    departmentNumber: number;
}

export const getDepartments = async (): Promise<Department[]> => {
    try {
        const response = await databases.listDocuments(
            DATABASE_ID,
            DEPARTMENT_COLLECTION_ID,
            [Query.orderAsc("departmentNumber")]
        );
        return response.documents as unknown as Department[];
    } catch (error) {
        console.error("Error obteniendo departamentos:", error);
        throw error;
    }
};

export const formatDepartmentName = (name: string): string => {
    return name
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const getSequenceDocument = async () => {
    try {
        const response = await databases.listDocuments(
            DATABASE_ID,
            DATA_SEQUENCES_COLLECTION_ID
        );

        if (response.documents.length > 0) {
            return {
                documentId: response.documents[0].$id,
                currentSequence: response.documents[0].colab_sequency || 0
            };
        }
        throw new Error("No se encontró el documento de secuencias");
    } catch (error) {
        console.error("Error obteniendo secuencia:", error);
        throw error;
    }
};

export const incrementSequence = async (documentId: string, newSequence: number): Promise<void> => {
    try {
        await databases.updateDocument(
            DATABASE_ID,
            DATA_SEQUENCES_COLLECTION_ID,
            documentId,
            { colab_sequency: newSequence }
        );
    } catch (error) {
        console.error("Error actualizando secuencia:", error);
        throw error;
    }
};

export const generateColabCode = (
    departmentNumber: number,
    birthday: string,
    sequence: number
): string => {
    const birthDate = new Date(birthday);
    const day = String(birthDate.getDate()).padStart(2, '0');
    const year = String(birthDate.getFullYear()).slice(-2);
    const seq = String(sequence).padStart(2, '0'); 

    return `${departmentNumber}${day}${year}${seq}`; 
};


// Extraer la secuencia de un código existente
export const extractSequenceFromCode = (code: string): number => {
    // Formato: [dept(1)][DD(2)][YY(2)][secuencia(resto)]  
    // Ejemplo: 9070125 → secuencia = 25
    if (code.length < 5) return 0;
    const sequencePart = code.slice(5); // Todo después de la posición 5
    return parseInt(sequencePart) || 0;
};

// Regenerar código manteniendo la secuencia
export const regenerateColabCode = (
    departmentNumber: number,
    birthday: string,
    existingCode: string
): string => {
    const sequence = extractSequenceFromCode(existingCode);
    return generateColabCode(departmentNumber, birthday, sequence);
};